var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-nav-main-titles"},[_c('ul',{staticClass:"c-nav-main-titles__list"},[_c('navigation-main-titles-logo'),_c('navigation-main-titles-neighbourhood')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }